import { Comment } from 'ca-api-client';

const initialState = () => ({
    currentItem: {},
    isLoading: false,
    comments: [],
    sidebar: 'SideBar',
    activeCommentStatus: null,
    addingComment: false,
    addingReply: false,
    viewingComment: false,
    marker: {
        left: 0,
        top: 0,
    },
});

const defaultComment = () => ({
    user_id: ca.user.uuid,
    status: 'incomplete',
    project_id: ca.project.uuid,
    team_only: 0,
    parent_id: null,
    markup: null,
    created_at: null,
});

const state = {
    ...initialState(),
};

const mutations = {
    setCommentsCurrentItem(state, item) {
        state.currentItem = item;
    },

    setCommentsIsLoading(state, loading) {
        state.isLoading = loading;
    },

    setComments(state, comments) {
        state.comments = comments;
    },

    setAddingComment(state, adding) {
        state.addingComment = adding;
        if (adding) state.sidebar = 'AddComment';
    },

    setAddingReply(state, adding) {
        state.addingReply = adding;
    },

    setViewingComment(state, viewing) {
        state.viewingComment = viewing;
        //state.sidebar = 'ViewComment';
    },

    setActiveCommentStatus(state, status) {
        state.activeCommentStatus = status;
    },

    setCommentSidebar(state, sidebar) {
        state.sidebar = sidebar;
    },

    setCommentsMarker(state, marker) {
        state.marker = marker;
    },

    setCommentsMarkerLeft(state, marker) {
        state.marker.left = marker;
    },

    setCommentsMarkerRight(state, marker) {
        state.marker.right = marker;
    },

    setCommentsState(state) {
        Object.assign(state, initialState());
    },

    prependComment(state, comment) {
        state.comments.unshift(comment);
    },

    appendComment(state, comment) {
        state.comments.push(comment);
    },

    appendCommentReply(state, reply) {
        const comment = state.comments.find((comment) => comment.id === reply.parent_id);

        if (comment.hasChildren) {
            comment.children.data.push(reply);
        } else {
            comment.children = { data: [reply] };
        }
        state.viewingComment = comment;
    },

    replaceComment(state, comment) {
        const index = state.comments.findIndex((item) => item.id === comment.id);
        if (index > -1) state.comments.splice(index, 1, comment);
    },
};

const getters = {
    getCommentsCurrentItem(state) {
        return state.currentItem;
    },

    getCommentsIsLoading(state) {
        return state.isLoading;
    },

    getComments(state) {
        return state.comments;
    },

    getAddingComment(state) {
        return state.addingComment;
    },

    getAddingReply(state) {
        return state.addingReply;
    },

    getViewingComment(state) {
        return state.viewingComment;
    },

    getCommentSidebar(state) {
        return state.sidebar;
    },

    getActiveCommentStatus(state) {
        return state.activeCommentStatus;
    },

    getCommentsMarker(state) {
        return state.marker;
    },

    getDefaultComment() {
        return defaultComment();
    },
};

const actions = {
    async fetchComments({ commit }, payload) {
        const params = {
            filter: { project_id: ca.project.uuid, parent_id: null },
        };

        if (payload.filters) params.filter = Object.assign({}, params.filter, payload.filters);

        const comments = await Comment.params(params).include('user').$get();

        commit('setComments', comments);

        return comments;
    },

    async fetchMediaComments({ commit, dispatch }, media_id) {
        const comments = await Comment.params({
            filter: { project_id: ca.project.uuid, media_id },
        })
            .include('user')
            .where('parent_id', null)
            .$get();

        commit('setComments', comments);

        return comments;
    },

    async fetchCommentReplies({ commit }, parent_id) {
        const comments = await Comment.params({
            filter: { project_id: ca.project.uuid },
        })
            .include('user')
            .where('parent_id', parent_id)
            .$get();

        return comments;
    },

    async addComment({ commit }, formData) {
        if (!formData.has('status')) formData.append('status', 'incomplete');
        formData.append('project_id', ca.project.uuid);

        const comment = new Comment();
        return await comment.add(formData);
    },

    // async addReply({ commit }, data) {
    //     data.status = 'incomplete';
    //     data.project_id = ca.project.uuid;

    //     const comment = new Comment(data);
    //     return await comment.save();
    // },

    async saveComment({ commit }, comment) {
        const item = await Comment.$find(comment.id);
        delete item.parent_id;
        delete item.attachment;
        item.status = comment.status;
        return await item.save();
    },

    resetCommentsState({ commit }) {
        commit('setCommentsState');
    },
};

export const comments = {
    state,
    mutations,
    getters,
    actions,
};
